<div class="banners-container" [class.transitioning]="isTransitioning()">
  <ng-container *ngIf="currentBanner(); else noBanners">
    <!-- Видео баннер -->
    <video 
      *ngIf="currentBanner()?.file_url && isVideoFormat(currentBanner()!.file_url)"
      [src]="currentBanner()?.file_url"
      class="banner-media"
      autoplay
      muted
      (loadeddata)="onVideoLoad($event)"
      (ended)="onVideoEnded()"
      (error)="onError()">
    </video>

    <!-- Изображение баннер -->
    <img 
      *ngIf="currentBanner()?.file_url && !isVideoFormat(currentBanner()!.file_url)"
      [src]="currentBanner()?.file_url"
      [alt]="currentBanner()?.title"
      class="banner-media"
      (load)="onImageLoad()"
      (error)="onError()">
  </ng-container>

  <ng-template #noBanners>
    <div class="no-banners">
      <p>Loading new banner...</p>
    </div>
  </ng-template>
</div>
